// ============================================================================
// FILE: src/modules/uploads/components/wizard/ImportStep.jsx
// MODULE: Generic Upload Framework
//
// PURPOSE:
// Display upload import processing status.
//
// RESPONSIBILITIES:
// - Display import progress state
// - Display import completion state
// - Display import failure state
//
// NOTES:
// - Presentational component only.
// - No API calls.
// - No business logic.
// ============================================================================
//
// AUTHOR:
// DizyPro ERP Development Team
// ============================================================================

import React from "react";

import {
    STATUS_IMPORTING,
    STATUS_COMPLETED,
    STATUS_FAILED
} from "../../constants/uploadConstants";

// ============================================================================
// Component
// ============================================================================

const ImportStep = ({
    wizard
}) => {

    const status =
        wizard?.upload?.import?.status ||
        wizard?.upload?.job?.status ||
        "";

    const importedRows =
        wizard?.upload?.import?.imported_rows ??
        wizard?.upload?.job?.imported_rows ??
        0;

    const totalRows =
        wizard?.upload?.job?.total_rows ??
        wizard?.upload?.validation?.total_rows ??
        0;

    // ========================================================================
    // Importing
    // ========================================================================

    if (status === STATUS_IMPORTING) {

        return (
            <div className="upload-step-status">

                <div className="status-icon">
                    ⏳
                </div>

                <h3>
                    Importing...
                </h3>

                <p>
                    Please wait while the validated records
                    are being imported.
                </p>

                <div className="upload-progress">

                    <div
                        className="upload-progress-bar"
                    />

                </div>

            </div>
        );
    }

    // ========================================================================
    // Import Completed
    // ========================================================================

    if (status === STATUS_COMPLETED) {

        return (
            <div className="upload-step-status success">

                <div className="status-icon">
                    ✓
                </div>

                <h3>
                    Import Completed
                </h3>

                <p>
                    The upload has been imported successfully.
                </p>

                <div className="import-result">

                    <strong>
                        {importedRows}
                    </strong>

                    <span>
                        of {totalRows} record
                        {totalRows === 1 ? "" : "s"} imported
                    </span>

                </div>

            </div>
        );
    }

    // ========================================================================
    // Import Failed
    // ========================================================================

    if (status === STATUS_FAILED) {

        return (
            <div className="upload-step-status error">

                <div className="status-icon">
                    ✕
                </div>

                <h3>
                    Import Failed
                </h3>

                <p>
                    The import could not be completed.
                    Please review the upload details.
                </p>

            </div>
        );
    }

    // ========================================================================
    // Default / Processing
    // ========================================================================

    return (
        <div className="upload-step-status">

            <div className="status-icon">
                ⏳
            </div>

            <h3>
                Processing Import...
            </h3>

            <p>
                Please wait while the upload is being processed.
            </p>

            <div className="upload-progress">

                <div
                    className="upload-progress-bar"
                />

            </div>

        </div>
    );
};

export default ImportStep;